
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'ResponsiveContainer',

  props: {
    cols: { type: String, default: '12' },
    sm: { type: String, default: '8' },
    md: { type: String, default: '6' },
    lg: { type: String, default: '5' },
    xl: { type: String, default: '4' },
  }
});
